import React from 'react'
import store from '../store'
import { Provider } from 'react-redux'

import { ContainerParent } from '../models/enums'
import type { RetorikMainComponentProps } from '../models/retorikTypes'

import { TelemetryProvider } from './Contexts/TelemetryContext'
import ErrorCollector from './Telemetry/ErrorCollector'
import GlobalProvider from './Contexts/GlobalProvider'
import ShadowRoot from './Common/ShadowRoot'
import RetorikConfigHandler from './Common/RetorikConfigHandler'

const RetorikNews = (props: RetorikMainComponentProps): JSX.Element => {
  // --------- /!\ -----------
  // Ne mettre ici que de la logique spécifique au retorikNews
  // Ce qui est commun avec RetorikWidget ou autres doit aller dans RetorikComposer ou ContextProvider
  // -------------------------

  return (
    <Provider store={store}>
      <TelemetryProvider>
        <GlobalProvider instanceId={props.instanceId}>
          <ShadowRoot>
            <ErrorCollector>
              <RetorikConfigHandler {...{ parent: ContainerParent.news, ...props }} />
            </ErrorCollector>
          </ShadowRoot>
        </GlobalProvider>
      </TelemetryProvider>
    </Provider>
  )
}

export default RetorikNews
